var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showCountdown
    ? _c("countdown", {
        attrs: { time: _vm.remainingTime },
        on: { end: _vm.onEnd },
        scopedSlots: _vm._u(
          [
            {
              key: "default",
              fn: function (props) {
                return [
                  _vm._v(
                    "\n    " + _vm._s(_vm.formatCountdown(props)) + "\n  "
                  ),
                ]
              },
            },
          ],
          null,
          false,
          2978946212
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }